import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleriaModule } from 'primeng/galleria';

@Component({
  selector: 'app-brand-visibility-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, GalleriaModule],
  templateUrl: './brand-visibility-card.component.html',
  styleUrls: ['./brand-visibility-card.component.scss'],
})
export class BrandVisibilityCardComponent {
  protected readonly screenshots = [
    'example_screenshot3.jpg',
    'app_screenshot2.jpg',
    'app_screenshot3.jpg',
    'example_screenshot4.jpg',
  ];
  protected currentScreenshot = this.screenshots[0];

  protected onScreenshotChange(event: any): void {
    this.currentScreenshot = event.value;
  }
}
